/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignAddonDestroyPathParams, CampaignAddonDestroyResponse } from '../types/CampaignAddonDestroy'

/**
 * DELETE /campaigns/:campaign/addon/:addon
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAddonController.php CampaignAddonController::destroy
 */
export async function campaignAddonDestroy(
	campaign: CampaignAddonDestroyPathParams['campaign'],
	addon: CampaignAddonDestroyPathParams['addon'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignAddonDestroyResponse>> {
	return axiosInstance.delete(`/campaigns/${campaign}/addon/${addon}`, config)
}
